import { render, staticRenderFns } from "./InvalidForm.vue?vue&type=template&id=5e09b006&scoped=true&"
import script from "./InvalidForm.vue?vue&type=script&lang=ts&"
export * from "./InvalidForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e09b006",
  null
  
)

export default component.exports